<script lang="ts" setup>
import HomepageBtn from './HomepageBtn.vue';
import useI18NAsync from '~/composables/i18nAsync';

const emit = defineEmits(['discoverSolidworks']);
const i18n = useI18NAsync('components/homepage/solidworks');
const i18nCommon = useI18NAsync('common');
</script>
<template>
  <div class="solidworks-instant-quote py-20px--sm py-30px px-10px--sm px-30px">
    <div
      class="homepage-max-content-container flex flex-column--sm align-items-center grid-gap-25px"
    >
      <div class="flex-grow-1">
        <h4 class="title text-center--sm">
          <i18n ikey="swGetInstantQuote" />
        </h4>
        <div class="subtitle text-center--sm">
          <i18n ikey="swDownloadAddin" />
        </div>
      </div>
      <div class="listed-btn-ctn sw-instant-buttons w-100--sm grid grid-2-columns grid-gap-10px">
        <HomepageBtn
          color="white"
          href="https://www.solidworks.com/support/free-downloads"
          target="_blank"
          class="download"
        >
          <i18nCommon ikey="download" />
        </HomepageBtn>
        <HomepageBtn color="blue-outline" @click="emit('discoverSolidworks')" class="discover">
          <i18nCommon ikey="discover" />
        </HomepageBtn>
      </div>
    </div>
  </div>
</template>
<style lang="css" scoped>
.solidworks-instant-quote {
  background-color: var(--blue-2);
  color: white;
}
</style>
